import useSWR from 'swr'
import api from '../api'
import { BEUrl } from '../types'

export function useFetch<T>(url: BEUrl) {
    const fetcher = async (resource: BEUrl) => {
        const response = await api.get<T[]>(resource)
        return response.data as T[]
    }

    const { data, error, isLoading } = useSWR<T[], Error>(url, fetcher)

    return {
        data,
        error,
        isLoading,
    }
}
